import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

const Breadcrumb = ({ location }) => {

    let [crumbs, setCrumbs] = useState([])

    useEffect(() => {
        let pathString = location.pathname
        if (!pathString || (!!pathString && pathString.length < 1)) return;

        let newCrumbs = location.pathname.split("/").filter(crumb => crumb.length > 0)
        if(newCrumbs.includes('blog')){
            newCrumbs = newCrumbs.slice(0, newCrumbs.indexOf('blog')+1)
        }
        setCrumbs(newCrumbs)
    }, [location.pathname])

    const concatPath = (index) => {
        let pathCrumbs = crumbs.slice(0, index)
        if(crumbs.includes('blog')){
            return '/resources'
        }
        return `/${pathCrumbs.join('/')}`;
    }

    const captilizeFirstLetters = (crumb) => {
        let words = crumb.split('-')
        words = words.map(word => word = word[0].toUpperCase() + word.slice(1, word.length))
        return words.join(' ')
    }

    return (
        <div className='text-white position-absolute font-sm mt-4' id="breadcrumbs">
            <Link to="/" className='text-white'>Home</Link>
            {
                !!crumbs && crumbs.map((crumb, i) => 
                    <React.Fragment key={`breadcrumb-${i}`}><span>/</span><Link to={concatPath(i + 1)} className='text-white'>{!!mapping[crumb] ? mapping[crumb] : captilizeFirstLetters(crumb)}</Link></React.Fragment>
                )
            }
        </div>
    )
}

export default Breadcrumb;

const mapping = {
    'enhance-and-manage': 'Enhance & Manage Content',
    'get-a-demo': 'Get a Demo',
    'roadmap': 'Walmart Roadmap',
    '404': '404: Not Found',
    'about': 'About Us',
    '1p-suppliers': '1P Suppliers',
    'clients-and-partners': 'Clients & Partners',
    'diagnose-and-fix': 'Diagnose & Fix Issues',
    'yellow-belt': 'Content Center (Yellow Belt)',
    'green-belt': 'Get Found (Green Belt)',
    'purple-belt': 'Insights (Purple Belt)',
    'blue-belt': 'Win Search (Blue Belt)',
    'cep': 'Content Excellence Program (CEP)',
    'elite-subscription': 'Get it All (Elite)',
    'terms': 'Terms & Conditions',
    'privacy': 'Privacy Policy',
    'sku-ninja': 'SKU Ninja'
}